module.exports = __webpack_public_path__ + "img/campo-grande.84d38b57.jpg";